import React from 'react';
import AnalyticsLocation from '@/constants/AnalyticsLocation';
import { useGoogleAnalytics } from '@/modules/GoogleAnalytics';

export const AnalyticsActionType = Object.freeze({
  CREATED: 'created',
  DELETED: 'deleted',
  UPDATED: 'updated',
});

export const AnalyticsTarget = Object.freeze({
  VIEW_TASK: 'view task',
  VIEW_TASKS: 'view tasks',
});

const TASK_ACTION = 'task_action';

export default function useTaskAnalytics() {
  const { sendEvent } = useGoogleAnalytics();
  const sendGABCreatedAction = React.useCallback(() => {
    sendEvent(TASK_ACTION, {
      location: AnalyticsLocation.GAB,
      action_type: AnalyticsActionType.CREATED,
    });
  }, []);

  const sendTasksListCreatedAction = React.useCallback(() => {
    sendEvent(TASK_ACTION, {
      location: AnalyticsLocation.TASKS,
      action_type: AnalyticsActionType.CREATED,
    });
  }, []);

  return {
    sendGABCreatedAction,
    sendTasksListCreatedAction,
  };
}
